import { render, staticRenderFns } from "./batchMove.vue?vue&type=template&id=7698c9d8&"
import script from "./batchMove.vue?vue&type=script&lang=js&"
export * from "./batchMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7698c9d8')) {
      api.createRecord('7698c9d8', component.options)
    } else {
      api.reload('7698c9d8', component.options)
    }
    module.hot.accept("./batchMove.vue?vue&type=template&id=7698c9d8&", function () {
      api.rerender('7698c9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/batchMove.vue"
export default component.exports